import {createApi} from '@reduxjs/toolkit/query/react';
import {customAxiosBaseQuery} from '../API/customAxiosBaseQuery';
import {BaseResponseType} from '../types/TypesStore';
import {deliveryAPI} from '../API/api';

import {
	OneAddressType,
	GetDeliveryAddressData,
	OneContactType,
	GetDeliveryContactsData,
} from '../types/DeliveryData';

export const deliveryApi = createApi({
	reducerPath: 'deliveryApi',
	baseQuery: customAxiosBaseQuery,
	tagTypes: ['addresses-list', 'contacts-list'],
	endpoints: (builder) => ({
		getAddressesList: builder.query<
			BaseResponseType & {addresses: OneAddressType[]},
			string
		>({
			query: (service_type) => ({
				func: deliveryAPI.getAddressesList,
				args: [service_type],
			}),
			providesTags: ['addresses-list'],
		}),
		createAddress: builder.mutation<BaseResponseType, GetDeliveryAddressData>({
			query: (data) => ({
				func: deliveryAPI.createNewAddress,
				args: [data],
			}),
			invalidatesTags: ['addresses-list'],
		}),
		getContactsList: builder.query<
			BaseResponseType & {contacts: OneContactType[]},
			string | undefined
		>({
			query: (supplier_id) => ({
				func: deliveryAPI.getContactsList,
				args: [supplier_id],
			}),
			providesTags: ['contacts-list'],
		}),
		createContact: builder.mutation<
			BaseResponseType & {contact_id: string},
			GetDeliveryContactsData
		>({
			query: (data) => ({
				func: deliveryAPI.createNewContacts,
				args: [data],
			}),
			invalidatesTags: ['contacts-list'],
		}),
	}),
});

export const {
	useGetAddressesListQuery,
	useCreateAddressMutation,
	useGetContactsListQuery,
	useCreateContactMutation,
} = deliveryApi;
